import React from "react";

import { AuthenticationContainer, StyledLoginFormContainer } from "../../components";
import type { PasswordResetVerifyData } from "../../schemas";

import { PasswordResetVerifyForm } from "./password-reset-verify-form";
import { PasswordResetVerifyTimer } from "./password-reset-verify-timer";

export interface PasswordResetVerifyTemplateProps {
	readonly onSubmit: (data: PasswordResetVerifyData) => void;
	readonly onResendCode: () => void;
	readonly onBackToLogin: () => void;
	readonly username: string;
	readonly timeLeft: number;
	readonly errorMessage: string | null;
}

export const PasswordResetVerifyTemplate: React.FC<PasswordResetVerifyTemplateProps> = ({
	onSubmit,
	onResendCode,
	onBackToLogin,
	username,
	timeLeft,
	errorMessage,
}) => {
	return (
		<AuthenticationContainer>
			<StyledLoginFormContainer maxWidth="sm">
				<PasswordResetVerifyForm onSubmit={onSubmit} username={username} errorMessage={errorMessage} />
				<PasswordResetVerifyTimer onResendCode={onResendCode} onBackToLogin={onBackToLogin} timeLeft={timeLeft} />
			</StyledLoginFormContainer>
		</AuthenticationContainer>
	);
};
